import { useSelector } from 'react-redux';
import dynamicfunction from '../../utils/dynamicfunction';
import { getContentKeyAccToLang } from '../../utils/utils';
import { useNavigate } from 'react-router';
import { useState } from 'react';

export default () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(null);
  const { TextWeight, isArabic } = dynamicfunction();
  const { helpContent } = useSelector((state) => state.content);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      helpContent?.faq?.data?.attributes,
      key,
      isArabic
    );
  };

  return {
    TextWeight,
    getContentKey,
    navigate,
    activeIndex,
    setActiveIndex,
    isArabic,
    helpContent,
  };
};
